import { america, findMission, type Mission } from '@/content/missions'
import { usePrefs } from './prefs'

const HEX = /^#[0-9a-f]{6}$/

function paletteOf(mission: Mission) {
  const { primary, secondary, accent } = mission.palette
  return [primary, secondary, accent].map((hex) => hex.toLowerCase())
}

/**
 * The three source colors behind the theme, the mission's own until one is
 * edited. Editing any of them switches to a custom palette.
 */
export function usePalette() {
  const { prefs, set } = usePrefs()
  const mission = findMission(prefs.mission) ?? america
  const custom = Boolean(prefs.palette)
  const colors = custom ? prefs.palette.split(',') : paletteOf(mission)
  const update = (index: number, value: string) => {
    const hex = (value.startsWith('#') ? value : `#${value}`).toLowerCase()
    if (!HEX.test(hex)) return false
    const next = [...colors]
    next[index] = hex
    set('palette', next.join(','))
    return true
  }
  const reset = () => set('palette', '')
  const customize = () => set('palette', paletteOf(mission).join(','))
  return { colors, custom, update, reset, customize }
}
